export default __webpack_public_path__ + "de44606f783d19bb479d80427eb2609e.svg";